export default [
  {
    name: 'Australian Capital Territory',
    iso2Code: 'ACT',
  },
  {
    name: 'New South Wales',
    iso2Code: 'NSW',
  },
  {
    name: 'Northern Territory',
    iso2Code: 'NT',
  },
  {
    name: 'Queensland',
    iso2Code: 'QLD',
  },
  {
    name: 'South Australia',
    iso2Code: 'SA',
  },
  {
    name: 'Tasmania',
    iso2Code: 'TAS',
  },
  {
    name: 'Victoria',
    iso2Code: 'VIC',
  },
  {
    name: 'Western Australia',
    iso2Code: 'WA',
  },
];
